import React, { Component, PureComponent } from 'react'
import { Dropdown } from 'semantic-ui-react'

const ALL_ICONS = []

export default function IconInput(props) {
  let { name = '', id = '', onChange, placeholder = 'Valitse ikoni', value, disabled = false } = props

  let classes = ['form-input', 'form-input--select']

  return (
    <Dropdown
      placeholder={placeholder}
      options={ALL_ICONS.map(i => ({ value: i, icon: i, text: i }))}
      value={value}
      disabled={disabled}
      selection
      search
      onChange={(e, { value = false } = {}) => onChange({ name, value })}
    />
  )
}
